import {MSCQ_SELECT_OPTION} from '../Redux.constants';

export const selectCheckboxOption = (params) => ({
  type: MSCQ_SELECT_OPTION,
  payload: params,
});
